import { IcsCalendarEventType } from './store/schema/IcsPreviewState';

const datapoints = {
    AddToCalendarServiceResult: {
        datapoint: {
            name: 'AddToCalendarServiceResult',
            customData: (
                status: string,
                numberOfEventsImported: number
            ): { [key: string]: string | number } => {
                return {
                    status: status,
                    numberOfEventsImported: numberOfEventsImported,
                };
            },
        },
    },
    SaveIcsToCalendarFromMultipleDialog: {
        datapoint: {
            name: 'SaveIcsToCalendarFromMultipleDialog',
            customData: (status: boolean): { [key: string]: boolean } => {
                return {
                    status: status,
                };
            },
        },
    },
    SxSAddToCalendar: {
        datapoint: {
            name: 'SxSAddToCalendar',
            customData: (icsCalendarEventType: IcsCalendarEventType, responseClass: string) => ({
                icsCalendarEventType,
                responseClass,
            }),
        },
    },
};

export default datapoints;
